import { createI18n } from 'vue-i18n'
import en from './en'
import ja from './ja'
import ko from './ko'
import zhTW from './zh-TW'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    ja,
    ko,
    'zh-TW': zhTW,
  },
})

export default i18n 